import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker"
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker"
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker"
import { TextField, InputAdornment } from "@mui/material"
import dayjs from "dayjs"
import EventRoundedIcon from "@mui/icons-material/EventRounded"
import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded"

export const DatePicker = (props) => {
  return (
    <MobileDatePicker
      {...props}
      inputFormat="DD-MM-YYYY"
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <EventRoundedIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  )
}

export const DateTimePicker = (props) => {
  return (
    <MobileDateTimePicker
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <EventRoundedIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  )
}

export const TimePicker = ({ error, helperText, ...props }) => {
  return (
    <MobileTimePicker
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          helperText={helperText}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <AccessTimeRoundedIcon />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  )
}
